module.exports = __webpack_public_path__ + "static/WebsiteCreator-fb1f4e37f396fc172a56926eb7a6c1a8.png";